module.exports = {
        srcSet: __webpack_public_path__ + "bc28b73fde1f125b-600.webp"+" 600w"+","+__webpack_public_path__ + "526b1ef0bc76427d-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "bc28b73fde1f125b-600.webp",width: 600,height: 400},{path: __webpack_public_path__ + "526b1ef0bc76427d-1000.webp",width: 1000,height: 667}],
        src: __webpack_public_path__ + "526b1ef0bc76427d-1000.webp",
        toString: function(){return __webpack_public_path__ + "526b1ef0bc76427d-1000.webp"},
        
        width: 1000,
        height: 667
      }